<template>
    <div aria-hidden="true">
        <div class="d-none d-lg-block" :style="{ height: height }"></div>
        <div class="d-lg-none" :style="{ height: mobileHeight }"></div>
    </div>
</template>

<script>
export default {
    name: "MarketingSpacer",
    props: {
        height: {
            type: String,
            default: "57px"
        },
        mobileHeight: {
            type: String,
            default: "28.5px"
        }
    }
};
</script>

<style scoped>
/* Add scoped styles here */
</style>
